import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { UserProxy } from 'src/app/core/store/user/user.proxy';
import { opacityInOut } from '../../animations/opacity-in-out.animation';
import { scaleInOut } from '../../animations/scale-in-out.animation';
import { HelperService } from 'src/app/core/services/helper.service';
import { AnimationOptions } from 'ngx-lottie';
import { Router } from '@angular/router';
import { DashboardProxy } from 'src/app/core/store/dashboard/dashboard.proxy';

@Component({
  selector: 'badges-notify',
  templateUrl: 'badges-notify.component.html',
  styleUrls: ['badges-notify.component.scss'],
  animations: [ opacityInOut, scaleInOut ]
})
export class BadgesNotifyComponent implements OnInit, OnDestroy {

  validationBadge = null;
  animationLoaded = false;
  optionsRocket: AnimationOptions = {    
    path: 'https://res.cloudinary.com/dteo0axta/raw/upload/v1716475448/assets/raketa_v001_yylpba.json'  
  };
  optionsStar: AnimationOptions = {    
    path: 'https://res.cloudinary.com/dteo0axta/raw/upload/v1716475454/assets/zvezda_v001_trueot.json'  
  };
  private badgeQueue = null;
  private skillsValidationSub: Subscription;

  constructor(
    private userProxy: UserProxy,
    private helperService: HelperService,
    private router: Router,
    private dashboardProxy: DashboardProxy
  ) {
  }

  ngOnInit(): void {
    this.userProxy.initSkillValidationCheck(); 
    this.skillsValidationSub = this.userProxy.skillsValidationNotify$.subscribe(res => {
      if (res) {
        this.badgeQueue = res;
        this.checkBadges();   
      }
    });
  }

  close() {
    this.validationBadge = null;
    this.helperService.blockScroll$.next(false);
    setTimeout(() => this.checkBadges(), 1000);
  }

  animationCreated($event) {
    this.animationLoaded = true;
  }


private checkBadges() {
  if (this.badgeQueue) {
    let navigateAfter = false;

    if (this.badgeQueue.jobTitleBadge.length) {
      this.validationBadge = { title: this.badgeQueue.jobTitleBadge[0].jobTitle, isSkill: false, type: 'jobTitle',reportUrl: this.badgeQueue.jobTitleBadge[0].reportUrl };
      this.badgeQueue.jobTitleBadge.shift();
      this.helperService.blockScroll$.next(true);
      navigateAfter = true;

    } else if (this.badgeQueue.skillBadge.length) {

      this.validationBadge = { title: this.badgeQueue.skillBadge[0].skill, isSkill: true, type: 'skill', reportUrl: this.badgeQueue.skillBadge[0].reportUrl };
      this.badgeQueue.skillBadge.shift();
      this.helperService.blockScroll$.next(true);
      navigateAfter = true;

    } else if (this.badgeQueue.branchBadge?.length) {

      this.validationBadge = { title: this.badgeQueue.branchBadge[0].branch, isSkill: false, type: 'branch' , reportUrl : this.badgeQueue.branchBadge[0].reportUrl};
      this.badgeQueue.branchBadge.shift();
      this.helperService.blockScroll$.next(true);
      navigateAfter = true;
    } else if (this.badgeQueue.softSkillBadge?.length) {

      this.validationBadge = { title: this.badgeQueue.softSkillBadge[0].jobTitle, isSkill: false, type: 'jobTitle' , reportUrl : this.badgeQueue.softSkillBadge[0].reportUrl};
      this.badgeQueue.softSkillBadge.shift();
      this.helperService.blockScroll$.next(true);
      navigateAfter = true;
    }

    if (
      !this.badgeQueue.jobTitleBadge.length &&
      !this.badgeQueue.skillBadge.length &&
      !this.badgeQueue.branchBadge?.length &&
      !this.badgeQueue.softSkillBadge?.length &&
      navigateAfter
    ) {
      this.router.navigate(['./talent/skills-validation']);
      this.dashboardProxy.recalculateMatch();
    }
  }
}
openReport(url: string) {
  if (url) {
    window.open(url, '_blank');
  }
}


  ngOnDestroy(): void {
    this.skillsValidationSub.unsubscribe();
  }

}
